export default __webpack_public_path__ + "static/media/Ostali 14.9ea0a0cd.jpg";